import { Component, Input, OnInit } from '@angular/core';
import { AllBusinessTypes} from '@portal-workspace/grow-shared-library';
import { NgClass } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'business-type-icon',
    templateUrl: './business-type-icon.component.html',
    styleUrls: ['./business-type-icon.component.scss'],
    standalone: true,
    imports: [MatTooltipModule, NgClass]
})
export class BusinessTypeIconComponent implements OnInit {
  @Input({required: true}) businessType!: AllBusinessTypes;

  constructor() { }

  ngOnInit(): void {
  }

}
